// src/context/LanguageContext.js

import React, { createContext, useState, useEffect, useContext } from 'react';
import { getTranslation } from '../locales/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Load saved language preference from localStorage
    const savedLanguage = localStorage.getItem('app_language');
    return savedLanguage || 'en';
  });

  const switchLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('app_language', newLanguage);
  };

  const t = (key) => {
    return getTranslation(key, language);
  };

  useEffect(() => {
    // Save language preference whenever it changes
    localStorage.setItem('app_language', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
